import { useContext } from 'react'
import { PopupMessageContext } from 'src/contexts'

export const useAddPopupMessage = () => {
  const { add } = useContext(PopupMessageContext)
  return add
}
